<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page"><router-link to="/pallet_inspections">Pallet Inspection</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Pallet Inspection View</li>
                </ol>
                <h4 class="main-title mb-0">Pallet Inspection</h4>
            </div>
            <router-link to="/pallet_inspections" type="submit" class="btn btn-primary"><i class="ri-list-check fs-18 lh-1"></i> Pallet Inspections</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header" style="border-bottom: none !important;">
                        <div class="nav nav-tabs mb-0" id="nav-tab" role="tablist">
                            <span>
                                <button class="nav-link" :class="{active:active}" @click="getBasicDetails()">Basic Information</button>
                            </span>
                            <span v-for="inspection_stage,key in inspection_stages" :key="key">
                                <button v-if="inspection_stage_active" :class="{active:inspection_stage.active}" class="nav-link" @click="getInspectionChecks(inspection_stage)">{{ inspection_stage.stage_name }}</button>
                                <button v-else class="nav-link" @click="getInspectionChecks(inspection_stage)">{{ inspection_stage.stage_name }}</button>
                            </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                
                                <InspectionChecks :item="inspection_checks" :basicDetail="inspection" :status="basic_detail_status" :inspection_attachments="inspection_attachments" :checkAttachmentStatus=false></InspectionChecks>
                                <div class="row g-2">
                                    <div class="col-md-3" v-for="inspection_attachment, key in inspection_attachments" :key="key">
                                        <div>
                                            <div class="card-header d-flex justify-content-between">
                                                <h6 class="card-title">Image</h6>
                                            </div>
                                            <div class="card-body">
                                                <img class="mb-2" width="100" height="100" :src="inspection_attachment.inspection_attachment_path" />
                                            </div>
                                            <div class="card-footer d-flex justify-content-between">
                                                <a :href="$store.getters.apiUrl+'downloadImage?filename='+inspection_attachment.inspection_attachment_name" target="_blank" class="btn btn-sm btn-primary">
                                                    Download<i class="ri-download-line fs-18 lh-1"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import InspectionChecks from "@/components/InspectionChecks.vue";
    export default {
        components: {
            Pagination,
            InspectionChecks,
        },
        data() {
            return {
                inspection: {
                    inspection_id: "",
                },
                inspections: [],
                inspection_stages: [],
                inspection_checks: [],
                inspection_attachments: [],
                errors: [],
                status: true,
                active: false,
                basic_detail_status: true,
                active: true,
                inspection_stage_active: false,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.inspection.inspection_id = to.params.inspection_id;
                let uri = { uri: "getInspection", data: vm.inspection };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.inspection = response.data.data;
                        vm.inspection_stages = response.data.data.inspection_stages;
                        vm.getBasicDetails();
                        if (vm.inspection_stages.length) {
                            vm.inspection_stage_id = vm.inspection_stages[0].inspection_stage_id;
                        }
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            });
        },
        mounted() {
            // this.getTrips();
        },

        methods: {
            getInspectionChecks(inspection_stage) {
                let vm = this;
                vm.active = false;
                vm.inspection_stages.map(function (el) {
                    el.active = false;
                });
                vm.inspection_stage_active = true;
                inspection_stage.active = true;

                let uri = { uri: "getInspectionChecks", data: { inspection_stage_id: inspection_stage.inspection_stage_id } };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        
                        vm.inspection_checks = response.data.data;
                        vm.inspection_attachments = response.data.inspection_attachments;
                        vm.basic_detail_status = false;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            getBasicDetails() {
                let vm = this;
                vm.inspection_stage_active = false;
                vm.active = true;
                let uri = { uri: "getInspection", data: vm.inspection };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.inspection = response.data.data;
                        vm.basic_detail_status = true;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
        },
    };
</script>
<style scoped>
    .no-border-bottom {
        border-bottom: 2px solid white;
    }
</style>
